import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Фартук изготовлен из приятного на ощупь глянцевого материала - сатена. Рисунок наносится методом сублимации на всю поверхность фартука.</p><p>Обшив косой бейкой. Длина 84-85 см, ширина 54-55 см.</p><p>Длина завязок 72 см и горловины 65 см.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
